.ux-iws-teaser-product-tile {
    box-sizing: border-box;
    display: block;
    width: 100%;
    max-width: 600px;
    line-height: 1.3;
    margin: 0;
    padding: 0;
    cursor: pointer;

    &__inner {
        position: relative;
        overflow: hidden;
    }

    &__layer {
        display: block;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: auto;
        height: auto;
        color: white;
    }

    &__image {
        width: 100%;
        height: 0;
        padding-bottom: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
    }

    &__logo-image {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    &__title {
        @include font(bold);
        font-size: $size-text-normal;

        @media only screen and (min-width: 1024px) {
            font-size: $size-text-normal-plus;
        }
    }

    &__desc {
        margin: $dim-15 0;
        max-width: 100%;
    }

    &__spacer {
        flex: 1 1 auto;
    }

    &__link {
        position: absolute;
        bottom: 30px;
        transform: translateY(20px);
        opacity: 0;
        left: 30px;
        transition: transform $animationSpeed-normal $animationEasing-ease,
            opacity $animationSpeed-medium ease-out,
            color $animationSpeed-normal $animationEasing-ease !important;
        color: $color-white;
    }

    &__link:hover {
        color: $color-green !important;

        ux-icon {
            color: $color-green;
        }
    }

    ux-icon {
        transition: fill $animationSpeed-normal $animationEasing-ease;

        &:hover {
            color: $color-green;
        }
    }

    .ux-text-link {
        @include font(bold);
        color: white;
        font-size: $size-text-small;
        text-transform: uppercase;
        text-decoration: none;

        &:hover {
            color: inherit;
        }
    }

    .ux-eyecatcher {
        z-index: auto;
    }
}

.ux-iws-teaser-product-tile-content {
    padding: $dim-30;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-end;
    opacity: 0;
    transition: opacity $animationSpeed-normal ease;
    background: linear-gradient(
        -180deg,
        transparentize($color-black-1, 1) 66.666%,
        transparentize($color-black-1, 0.6) 100%
    );

    &.is-visible {
        opacity: 1;
    }
}

.ux-iws-teaser-product-tile-overlay {
    pointer-events: none;
    opacity: 0;
    transition: opacity $animationSpeed-normal ease;
    z-index: 2;

    &.is-visible {
        pointer-events: auto;
        opacity: 1;
    }

    &.is-visible .ux-iws-teaser-product-tile__link {
        transform: translateY(0);
        opacity: 1;
    }

    &__bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: $color-blue-overlay;
        pointer-events: none;
    }

    &__content {
        padding: $dim-30;
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: stretch;
        overflow-x: hidden;
        overflow-y: hidden;
        cursor: pointer;
    }
}

.ux-iws-teaser-product-tile-grid {
    @supports (display: grid) {
        display: grid;
        grid-column-gap: 16px;
        grid-row-gap: 16px;
        grid-template-columns: repeat(auto-fit, minmax(300px, 20%));
    }

    @supports not (display: grid) {
        display: flex;
        flex-flow: row wrap;
        margin: -8px;

        .ux-iws-teaser-product-tile {
            flex: 1 0 300px;
            padding: 8px;
        }
    }
}
